import { GiftForm } from '@piconetworks/gift'
import withInjection from '@piconetworks/with-injection'

import WizardRedux from 'common/pkgs/WizardRedux'
import Loader from 'common/modules/loader'
import Wizard from 'common/modules/wizard'

const mapStateToProps = (state, props) => {
    const { router } = props
    const thisWizard = Wizard.selectors.thisWizard({ state, router })

    return {
        ...props,
        WizardRedux,
        thisWizard: Wizard.selectors.thisWizard({ state, router }),
        headerText: 'Go to Inbox Trips',
        headerDescription: 'Already a subscriber?',
        loader: Loader.selectors.loader(state),
        getScopedLoader: (scope) => Loader.selectors.scopedLoader(state, scope),
        onBackButtonClick: () => {
            router.replace({
                pathname: '/select-plan',
                query: {
                    ...(thisWizard?.id && { id: thisWizard.id }),
                },
            }, {
                pathname: '/select-plan',
                query: {
                    ...(thisWizard?.id && { id: thisWizard.id }),
                },
            })
        },
    }
}

const InjectedGiftForm = withInjection(GiftForm, {
    mapStateToProps,
})

export default InjectedGiftForm
